import * as React from 'react';
import { EditIcon, Button } from '@shortlyster/ui-kit';
import Table from 'src/components/Table';
import Link from '../../../components/Link';
import { Sso } from '../queries';
import { Pill, ToggleTip, Text } from '@compono/ui';
import SimpleDate from 'src/components/Date';

interface Props {
  ssoDatas: Sso[];
  organisationId: string;
}

const OrganisationsSsoList = ({ ssoDatas, organisationId }: Props) => (
  <Table>
    <thead>
      <tr>
        <th style={{ width: '40%', textAlign: 'left' }}>Name</th>
        <th style={{ width: '10%', textAlign: 'left' }}>Type</th>
        <th style={{ width: '10%', textAlign: 'left' }}>Status</th>
        <th style={{ width: '20%', textAlign: 'left' }}>Created By</th>
        <th style={{ width: '10%', textAlign: 'left' }}>Created At</th>
        <th style={{ width: '10%', textAlign: 'left' }}>Modify</th>
      </tr>
    </thead>
    <tbody>
      {ssoDatas.map((ssoData, index) => {
        return (
          <tr key={`sso-${index}`}>
            <td>{ssoData.name}</td>
            <td>{ssoData.type}</td>
            <td>
              {ssoData.enabled ? (
                <Pill tone="success">Active</Pill>
              ) : (
                <Pill tone="critical">Inactive</Pill>
              )}
            </td>
            <td>
              <Text>
                {ssoData.isComponoAdmin ? 'Compono Admin' : 'Organisation Admin'}
                <ToggleTip label={`UserId: ${ssoData.createdBy}`}>
                  UserId: {ssoData.createdBy}
                </ToggleTip>
              </Text>
            </td>
            <td>
              <SimpleDate date={ssoData.createdAt} />
            </td>
            <td>
              <Link to={`/organisations/${organisationId}/sso/${ssoData.id}`}>
                <Button icon={EditIcon}>Edit</Button>
              </Link>
            </td>
          </tr>
        );
      })}
    </tbody>
  </Table>
);

export default OrganisationsSsoList;
